var render = function render(){var _vm=this,_c=_vm._self._c;return _c('detail',{attrs:{"on-manager":_vm.onManager,"data":_vm.resultData,"base-info":_vm.baseInfo,"resource":"customers","nameProps":{ edit: false }}})
}
var staticRenderFns = []

export { render, staticRenderFns }